import type { ApiRoute, NoQueryParams } from "../../../api"
import type { VisibilityValues } from "../../../common/visibility/VisibilityValues"
import type { VisibilityView } from "./VisibilityView"

export interface UpdateVisibilityPathParams {
	inventoryId: string
}

export const updateVisibilityRoute: ApiRoute<
	UpdateVisibilityPathParams,
	NoQueryParams,
	VisibilityValues,
	VisibilityView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/visibility`,
	method: "patch",
	path: "/vehicles/:inventoryId/visibility",
}
